document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('.section-faq-menu--category-name');
  const scrollContainer = document.querySelector('.section-faq-menu--categories-wrapper .page-width');

  if (links.length > 0) {
    links[0].classList.add('active');
  }

  const faqCategoryTargets = document.querySelectorAll('[id].section-faq-categories--category-target');
  const targets = Array.from(faqCategoryTargets);

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const link = document.querySelector(`.section-faq-menu--category-name[href="#${id}"]`);

        if (entry.isIntersecting) {
          links.forEach(l => l.classList.remove('active'));
          if (link) {
            link.classList.add('active');

            if (scrollContainer) {
              const linkRect = link.getBoundingClientRect();
              const containerRect = scrollContainer.getBoundingClientRect();
              const offset = linkRect.left - containerRect.left - (containerRect.width / 2) + (linkRect.width / 2);
              scrollContainer.scrollBy({
                left: offset,
                behavior: 'smooth'
              });
            }
          }
        }
      });
    },
    {
      rootMargin: '0px 0px -60% 0px',
      threshold: 0.1
    }
  );

  targets.forEach(el => observer.observe(el));
  links.forEach(link => {
    link.addEventListener('click', function () {
      links.forEach(l => l.classList.remove('active'));
      this.classList.add('active');

      if (scrollContainer) {
        const linkRect = this.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const offset = linkRect.left - containerRect.left - (containerRect.width / 2) + (linkRect.width / 2);
        scrollContainer.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }
    });
  });
});
